import { createWaiverTemplate } from "../../api/historyService";

export const useCreateWaiverTemplate = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createWaiverTemplate(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create waiver template:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};